<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    dense
                    :label="$t('name')"
                    v-model="form.name"
                    outlined
                    hide-details
                    :rules="[isRequired]"
                    >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    dense
                    :label="$t('dimension')"
                    v-model="form.dimension_id"
                    outlined
                    hide-details
                    :items="dimensions"
                    :loading="dimensionsLoading"
                    item-text="name"
                    item-value="id"
                    :rules="[isRequired]"
                    @update:search-input="searchDimensions"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from './../../utils/validations';
import dimension from './../../services/sales/dimension';
export default {
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                name: null,
                dimension_id: null
            },
            dimensions: [],
            dimensionsLoading: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    methods: {
        isRequired,
        searchDimensions(query) {
            this.dimensionsLoading = true;
            dimension.search(query).then(res => {
                this.dimensions = [...this.dimensions, ...res.data];
            }).finally(() => {
                this.dimensionsLoading = false;
            })
        }
    },
    created() {
        this.form = {...this.value}
    }
}
</script>

<style>

</style>